import type { JobResponse } from "@unbox/api";
import { useMemo } from "react";
import { useJobFailures } from "@/api/jobs";
import { BulkActionResultsDialog } from "@/components/assurance/bulk-action-results-dialog";
import { jobToast } from "@/lib/jobs";

/** The results dialog for a job, with its failures read from the jobs endpoint rather than the event. */
export const JobResultsDialog = ({ job, onClose }: { job: JobResponse; onClose: () => void }) => {
  const { data: failures } = useJobFailures(job.id);

  const results = useMemo(
    () => ({
      totalProcessed: job.succeeded + job.failed,
      totalFailed: job.failed,
      failedCreators: (failures ?? []).map((item) => ({
        creatorId: item.itemKey,
        error: item.errorMessage ?? item.errorCode ?? "Unknown error",
        retryable: false,
      })),
    }),
    [job, failures],
  );

  if (!failures) return null;

  return (
    <BulkActionResultsDialog
      completion={results}
      actionType={jobToast(job.kind)?.actionType ?? job.kind}
      onClose={onClose}
    />
  );
};
